"use strict";

exports.__esModule = true;
exports.StyledScrollArea = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _simplebarReact = _interopRequireDefault(require("simplebar-react"));

require("simplebar/dist/simplebar.min.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledScrollArea = (0, _styledComponents.default)(({
  children,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_simplebarReact.default, { ...otherProps,
  children: children
}))`
    display: block;

    .simplebar-scrollbar:before {
        background: ${props => props.theme.colors.secondaryText};
    }
`;
exports.StyledScrollArea = StyledScrollArea;